import cardValidator from 'card-validator';

import { isExist, isEmpty } from 'util/helper';
import { ORDER_ITEM_EXTRA_PERSON_ID } from 'util/rent';

export const isValidOrNot = item => (item.status === 'VALIDATED' ? item.valid : true);

const codes = '0123456789ABCDEFGHJKLMNPQRSTUVXYWZIO';
const codesMap = {};

codes.split('').forEach((code, i) => {
	codesMap[code] = i;
});

export const examCertificate = certificate => {
	if (certificate.length !== 10) {
		return false;
	}
	try {
		const sum = certificate.split('').reduce((prev, cur, i) => {
			const codeNumber = codesMap[cur];

			if (typeof codeNumber === 'undefined') {
				throw new Error('Not certificate');
			}

			// First Number
			if (i === 0) {
				const firstCheck = Math.floor(codeNumber / 10);
				const secondCheck = (codeNumber % 10) * 9;

				return prev + firstCheck + secondCheck;
			}

			// Last Number
			if (i === 9) {
				return prev + codeNumber;
			}

			// 1~8
			const normalNumber = codeNumber * (9 - i);
			return prev + normalNumber;
		}, 0);

		return sum % 10 === 0;
	} catch (e) {
		console.log(e);

		return false;
	}
};

export const examUserData = (user, userIgData, phone) => {
	const keyArray = ['name', 'birth', 'country', 'expect', 'nickname', 'image'];

	const result = {
		value: keyArray.every(key => isExist(user[key])),
		notValid: keyArray.filter(key => isEmpty(user[key])),
	};

	if (user.gender === 'OTHER' || isEmpty(user.gender)) {
		result.notValid.push('gender');
		result.value = false;
	}

	if (user.certificate_type === null || user.certificate_number === '') {
		result.notValid.push('certificate');
		result.value = false;
	}

	if (!phone.validate || isEmpty(user.phone) || isEmpty(user.phone_country)) {
		result.notValid.push('phone');
		result.value = false;
	}

	if (
		(typeof user.social_media.length === 'undefined' || user.social_media.length === 0) &&
		userIgData.id === ''
	) {
		result.notValid.push('social_media');
		result.value = false;
	}

	const arrayResult = ['job_types', 'professions', 'interests'].every(
		key => typeof user[key] !== 'undefined' && user[key].length !== 0,
	);

	const arrayNotValid = ['job_types', 'professions', 'interests'].filter(
		key => typeof user[key] === 'undefined' || user[key].length === 0,
	);

	return {
		value: result.value && arrayResult,
		notValid: [...result.notValid, ...arrayNotValid],
	};
};

export const examUserCertificateData = user => {
	const result = {
		value: true,
		notValid: [],
	};

	if (
		user.certificate_type === null ||
		user.certificate_number === '' ||
		(user.certificate_type === 'IDENTITY' && !examCertificate(user.certificate_number))
	) {
		result.notValid.push('certificate');
		result.value = false;
	}

	return result;
};

const USER_KEY_MAP = {
	name: '真實姓名',
	gender: '生理性別',
	birth: '生日',
	country: '國家',
	certificate: '身份證',
	job_types: '工作型態',
	professions: '專長',
	phone: '聯絡電話',
	expect: '社群想像',
	nickname: '顯示名稱',
	company: '公司',
	career: '職業',
	intro: '社群短自介',
	interests: '興趣標籤',
	songs: 'Favorite Song',
	social_media: '社群帳號連結',
	image: '頭像',
};

export const userNameFrom = keys => keys.map(key => USER_KEY_MAP[key]);

export const examPassword = password =>
	isExist(password) && /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(password);

const ORDER_POLICY_KEY_MAP = {
	name: 'name',
	certificate_number: 'certificate',
	certificate_type: 'certificateType',
	address: 'address',
	extra_certificate_number: 'extraCertificate',
	extra_certificate_type: 'extraCertificateType',
	emergency_contact: 'emergencyContact',
	emergency_contact_mobile: 'emergencyContactMobile',
	emergency_contact_mobile_country_code: 'emergencyContactMobile',
	emergency_contact_relationship: 'emergencyContactRelationship',
	order_item_id: 'orderItem',
	certificate_file: 'certificateFile',
	extra_certificate_file: 'extraCertificateFile',
	emergency_address: 'emergencyAddress',
};

export const orderPolicyKeyFrom = keys => keys.map(key => ORDER_POLICY_KEY_MAP[key]);

export const examOrderPolicyData = order => {
	const keyArray = [
		'address',
		'emergency_contact',
		'emergency_contact_mobile',
		'emergency_contact_relationship',
		'emergency_address',
	];

	const result = {
		value: keyArray.every(key => isExist(order[key])),
		notValid: keyArray.filter(key => isEmpty(order[key])),
	};

	const certificateResult = {
		value: true,
		notValid: [],
	};

	if (order.certificate_file.fileName === '' || order.certificate_file.file === null) {
		certificateResult.value = false;
		certificateResult.notValid.push('certificate_file');
	}

	// Have 第二人入住
	if (order.order_item_id.includes(ORDER_ITEM_EXTRA_PERSON_ID)) {
		if (!['IDENTITY', 'PASSPORT'].includes(order.extra_certificate_type)) {
			certificateResult.value = false;
			certificateResult.notValid.push('extra_certificate_type');
		}

		if (
			order.extra_certificate_type === 'IDENTITY' &&
			!examCertificate(order.extra_certificate_number)
		) {
			certificateResult.value = false;
			certificateResult.notValid.push('extra_certificate_number');
		}

		if (
			order.extra_certificate_file.fileName === '' ||
			order.extra_certificate_file.file === null
		) {
			certificateResult.value = false;
			certificateResult.notValid.push('extra_certificate_file');
		}
	}

	return {
		value: result.value && certificateResult.value,
		notValid: [...result.notValid, ...certificateResult.notValid],
	};
};

const CREDIT_KEY_MAP = {
	card_number: 'cardNumber',
	expiry_year: 'expireYear',
	expiry_month: 'expireMonth',
	security_code: 'cvc',
	credit_name: 'name',
};

export const creditKeyFrom = keys => keys.map(key => CREDIT_KEY_MAP[key]);

export const examCreditData = credit => {
	const keyArray = ['credit_name'];

	const result = {
		value: keyArray.every(key => isExist(credit[key])),
		notValid: keyArray.filter(key => isEmpty(credit[key])),
	};

	const checkCreditNumber = cardValidator.number(credit.card_number);

	if (
		!checkCreditNumber.isValid ||
		!['visa', 'mastercard', 'jcb'].includes(checkCreditNumber.card.type)
	) {
		if (
			process.env.NODE_ENV === 'production' ||
			(process.env.NODE_ENV !== 'production' && credit.card_number !== '4000221111111111')
		) {
			result.notValid.push('card_number');
			result.value = false;
		}
	}

	const checkCreditDate = cardValidator.expirationDate({
		month: credit.expiry_month,
		year: credit.expiry_year,
	});

	if (!checkCreditDate.isValid) {
		result.notValid.push('expiry_year');
		result.notValid.push('expiry_month');
		result.value = false;
	}

	if (!cardValidator.cvv(credit.security_code).isValid) {
		result.notValid.push('security_code');
		result.value = false;
	}

	return {
		value: result.value,
		notValid: result.notValid,
	};
};



// WEBPACK FOOTER //
// ./src/util/exam.js